import { render, staticRenderFns } from "./ManageDownQueue.vue?vue&type=template&id=1b33f04e&"
import script from "./ManageDownQueue.vue?vue&type=script&lang=js&"
export * from "./ManageDownQueue.vue?vue&type=script&lang=js&"
import style0 from "./ManageDownQueue.vue?vue&type=style&index=0&id=1b33f04e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports